export default {"src":"/_next/static/media/stepper_arrow.505d0f52.svg","height":8,"width":10,"blurWidth":0,"blurHeight":0};